<template>
  <div class="image">
    <image-layout :loading="loading" :images="images"/>
  </div>
</template>

<script>
import db from '../../config/db'
import ImageLayout from '@/components/ImageLayout.vue'

export default {
  components: {
    ImageLayout
  },

  data () {
    return {
      images: [],
      loading: true
    }
  },

  mounted () {
    this.FirebaseImages()
    this.$store.commit('checkENV')
  },

  methods: {
    FirebaseImages () {
      const vm = this
      let ImageList = []
      let i = 1

      db.storing.ref('gallery' + this.$store.state.env + '/')
        .listAll()
        .then((res) => {
          res.items.forEach((itemRef) => {
            const dbInfo = db.storing.ref('gallery' + this.$store.state.env + '/').child(itemRef.name)
            dbInfo
              .getDownloadURL()
              .then((downloadURL) => {
                dbInfo
                  .getMetadata()
                  .then((metadata) => {
                    ImageList.push(
                      {
                        id: i,
                        imageURL: downloadURL,
                        date: new Date(metadata.timeCreated)
                      }
                    )
                    i++
                    ImageList = ImageList.sort((a, b) => b.date - a.date)
                  })
              })
          })
          vm.images = ImageList
          vm.loading = false
        })
    }
  }
}

</script>
